// https://docs.google.com/spreadsheets/d/1wThv1fd5ervHMq2OhYfAVP1Zs-NZDXFtxxq3YAeeHHY
export const pickZoomLevel = (clusterSize: number) => {
	if (clusterSize === 0.1) {
		return 11;
	}
	return Math.floor(10 * (7.5 + 0.39 / clusterSize)) / 10;
};
